import store from "~/js/store/store";
export default class NarrowDown {
  constructor(contents, select_toggle) {
    this.contents = contents;
    if (!this.contents) {
      return;
    }
    //選択変更された場合に閉じる
    this.select_toggle = select_toggle;
    this.opener = this.contents.querySelector("._opener");
    this.listContainer = this.contents.querySelector("._listContainer");

    this.isOpen = false;
    this.isOver = false;

    this.timer;

    this.setup();
  }

  setup() {
    this.listContainer.addEventListener("focusin", (event) => {
      this.stopTimer();
    });
    this.listContainer.addEventListener("focusout", (event) => {
      this.setTimer();
    });
    this.opener.addEventListener("click", (event) => {
      event.preventDefault();
      if (!this.isOpen) {
        this.isOpen = true;
        this.contents.classList.add("open");

        setTimeout(
          function () {
            this.contents.focus();
          }.bind(this),
          300
        );
      } else {
        this.isOpen = false;
        this.contents.classList.remove("open");
      }
    });

    if (!store.getters["isSP"]()) {
      //PC
      document.addEventListener("mousedown", (event) => {
        if (!this.isOver) {
          // event.preventDefault();
          this.contents.classList.remove("open");
        }
      });
      this.contents.addEventListener("mousedown", (event) => {
        this.isOver = true;
      });
      this.contents.addEventListener("mouseup", (event) => {
        this.isOver = false;
      });
    }

    //選択後、dropdownを閉じる
    if(this.select_toggle){
      this.listContainerInput = this.listContainer.querySelectorAll("input")
      for (let index = 0; index < this.listContainerInput.length; index += 1) {
        const element = this.listContainerInput[index];
        element.addEventListener("change", this.setTimer.bind(this));
      }
    }
  }

  setTimer() {
    clearTimeout(this.timer);
    this.timer = setTimeout(this.setTimerComplete.bind(this), 300);
  }
  stopTimer() {
    clearTimeout(this.timer);
  }
  setTimerComplete() {
    this.isOpen = false;
    this.contents.classList.remove("open");
  }
}
